import { DatePicker } from "antd";
import { DatePickerRules } from "../../types/field";
import moment from "moment";
import React, { useState } from "react";
import type { Moment } from 'moment';
import momentGenerateConfig from 'rc-picker/lib/generate/moment';

const MyDatePicker = DatePicker.generatePicker<Moment>(momentGenerateConfig);

type CustomDatePickerProps = {

  title: string;
  placeholder?: string;
  onChange?: any;
  disabled?: boolean;
  data?: any;
  className?: string;
  showTime?: boolean;
  clearIcon?: boolean;
  rules?: DatePickerRules;
  register?: any;
  id: string;
  name: string;
  setValue?: any;
  control: any;
  warning?: string;
  currentValue?:any;

};

const CustomDateTimePicker: React.FC<CustomDatePickerProps> = ({
  title,
  data,
  onChange,
  disabled,
  rules,
  id,
  name,
  control,
  setValue,
  warning,
  showTime=false,
  clearIcon=true
}) => {

  const payloadFormat = "YYYY-MM-DD HH:mm:ss";
  const displayFormat = "DD-MMM-YYYY HH:mm";

  const [compDate, setCompDate] = useState<moment.Moment | undefined>(data ? moment(data, payloadFormat) : undefined);
  
  const disabledDate = (current: number | moment.Moment) => {

    if (rules?.startDate || rules?.default === "currentDate") {
      if (Number(rules?.minDate) > 0) {
        return !(
          current < moment().add(Number(rules.minDate.substring(1)), "day") &&
          current > moment().add(Number(rules.minDate.substring(1)) + 1, "day")
        );
      } else if (Number(rules?.minDate) === 0) {
        return !(
          current < moment().add(rules.maxDate, "day") &&
          current > moment().subtract(Number(rules.minDate.substring(1)) + 1, "day")
        );
      }
      else {
        return !(
          current < moment().add(Number(rules.maxDate.substring(1)), "day") &&
          current > moment().subtract(Number(rules.minDate.substring(1)) + 1, "day")
        );
      }

    }
    current = moment(rules?.startDate);
    return !(
      current < moment().add(rules?.maxDate, "day") &&
      current > moment().subtract(rules?.minDate.substring(1), "day")
    );
  };

 
  return (

        <>
          <MyDatePicker
            className="w-100"
            showSecond={false}
            showTime
            disabledDate={disabledDate}
            disabled={disabled}
            format={displayFormat}
            id={id}
            // {...field}
            onChange={(value) => {
              // let date = value === null ? "" : (moment(value).format(payloadFormat)+":00");
              // field.onChange(date);
              setCompDate(value === null ? undefined : moment(value, payloadFormat));
              // field.value = date;
              onChange(value.format(payloadFormat));
            }}

            value={compDate}
          />

          {/* {warning && (
            <div className="ant-form-item-explain-warning">
              {warning}
            </div>
          )} */}
        </>
      
  );
};
// default props
CustomDateTimePicker.defaultProps = {

};

export default CustomDateTimePicker;
